import ConfirmarExclusao from 'global/guides/Dialog/ConfirmarExclusao'
import { useEscalasOutletContext } from 'pages/Escalas.context'
import { useNavigate, useParams } from 'react-router-dom'
import { escalas } from 'service/api/endpoints/escalas'
import { toast } from 'sonner'

function ExcluirEscala() {
    const { id } = useParams()
    const navigate = useNavigate()

    const { isLoading, mutate } = escalas.mutations.useDelete({
        invalidateQuery: true,
    })

    const data = useEscalasOutletContext().data.find(
        item => item.id === Number(id),
    )

    const handleSubmit = () => {
        mutate(Number(id), {
            onSuccess: () => {
                toast.success('Escala removida com sucesso!')
                navigate(-1)
            },
            onError: err => {
                if (err.statusCode === 400) {
                    toast.error(err.message)
                } else {
                    toast.error('Erro ao remover escala')
                }
            },
        })
    }

    return (
        <ConfirmarExclusao
            width="md"
            loading={isLoading}
            onConfirm={handleSubmit}
            fecharAoConfirmar={false}
            title={
                <>
                    Você tem certeza que deseja excluir a escala{' '}
                    {data?.descricao}?
                </>
            }
        />
    )
}

export default ExcluirEscala
